import { Language } from '@quizdb/common';

/** One Tesseract paragraph block, with confidence on Tesseract's 0–100 scale (PHO-D7). */
export interface OcrBlock {
  text: string;
  confidence: number;
}

/** A loaded Tesseract worker, reading one page's image at a time. */
export interface OcrEngine {
  read(image: Blob): Promise<string>;
  terminate(): Promise<void>;
}

/**
 * Loads an OCR engine for `language`. Rejects with `MaterialPrepError('OcrUnavailable')` when
 * the engine or the language model fails to load (PHO-D11).
 */
export type CreateOcr = (language: Language) => Promise<OcrEngine>;

/**
 * Maps each page `Language` to Tesseract's model code, which is also the `@tesseract.js-data/*`
 * package name (PHO-D1, PHO-D2).
 */
export const OCR_LANGUAGES: Record<Language, string> = {
  sv: 'swe',
  en: 'eng',
  da: 'dan',
  nb: 'nor',
  fi: 'fin',
  fr: 'fra',
  es: 'spa',
  it: 'ita',
  de: 'deu',
};

/** Where the web build serves the OCR engine's self-hosted assets from (PHO-D2). */
export const OCR_ASSET_PATH = '/ocr';
